import { CTN, Stack } from '@zet/design-system'

import { i18n } from '../localization'

export const ApplicationMap = {
  under_review: (
    <Stack className="text-secondary-150 border-secondary-150 rounded-full border px-2">
      <CTN className="font-bold">{i18n.t('applicationStatus.underReview')}</CTN>
    </Stack>
  ),
  application_rejected: (
    <Stack className="text-error-150 border-error-150 rounded-full border px-2">
      <CTN className="font-bold">
        {i18n.t('applicationStatus.applicationRejected')}
      </CTN>
    </Stack>
  ),
  correction_required: (
    <Stack className="text-warning-150 border-warning-150 rounded-full border px-2">
      <CTN className="font-bold">
        {i18n.t('applicationStatus.correctionRequired')}
      </CTN>
    </Stack>
  ),
  dispatched: (
    <Stack
      className="text-success-20 border-success-20 rounded-full border px-2"
      style={{ backgroundColor: '#174719', borderColor: '#95D68F' }}
    >
      <CTN className="font-bold" style={{ color: '#95D68F' }}>
        {i18n.t('applicationStatus.beingDispatched')}
      </CTN>
    </Stack>
  ),
}
